import { createRouter, createWebHistory } from 'vue-router';
import { useAppStore } from '@globals/stores/app';
import routes from './routes';

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.afterEach((to, from) => {
	const appStore = useAppStore();
	appStore.pathname = document.location.pathname;
});

export default router;
